import { ref, type Ref } from "vue"
import { defineStore } from "pinia"
import { type IDialog } from "@/interfaces/component/dialog.interface"

export const useDialogStore = defineStore("useDialogStore", () => {
  const currentDialog: Ref<IDialog | null> = ref(null)

  return {
    currentDialog
  }
})
